export default "__VITE_ASSET__CiUJ7o9f__"